import {Component, OnDestroy, OnInit} from '@angular/core';
import {
    NotificationsService
} from '../../_metronic/partials/layout/extras/dropdown-inner/notifications-dropdown-inner/notifications.service';
import * as moment from 'moment/moment';

@Component({
    selector: 'app-all-notifications',
    templateUrl: './all-notifications.component.html',
    styleUrls: ['./all-notifications.component.scss']
})
export class AllNotificationsComponent implements OnInit, OnDestroy {


    // Notification Data
    allNotifications = [];
    numberOfNewNotifications = 0;

    // Sorting
    dataSize = 20;
    maxDataSize = 0;

    // Subscriptions
    subscriptions = [];


    constructor(private notificationsService: NotificationsService) {
    }

    ngOnInit(): void {
        this.currentUserNotifications();
    }


    currentUserNotifications() {

        const newNotifications = this.notificationsService.getNewNotificationNumber().subscribe((notifNumber: any) => {
            this.numberOfNewNotifications = notifNumber.number;
        });

        const notifications = this.notificationsService.currentUserNotifications('0', this.dataSize).subscribe((notifs: any) => {
            this.allNotifications = [];
            this.maxDataSize = notifs.totalElements;

            notifs.content.forEach(notification => {
                this.allNotifications.push({
                    id: notification.id,
                    title: notification.message,
                    link: notification.createdObjectId,
                    createdAt: moment(notification.creationDate).fromNow(),
                    type: notification.type,
                    category: notification.category,
                    status: notification.usersListStatus[0].status
                });
            });

        });

        this.subscriptions.push(notifications, newNotifications);
    }


    // Mark as Read
    markAllAsRead() {
        const markAllAsRead = this.notificationsService.markAllAsRead().subscribe(data => {
            this.currentUserNotifications();
        });
        this.subscriptions.push(markAllAsRead);
    }

    markOneAsRead(id) {
        const markOneAsRead = this.notificationsService.markOneAsRead(id).subscribe(data => {
            this.currentUserNotifications();
        });
        this.subscriptions.push(markOneAsRead);
    }

    // Clear notification
    clearAllNotification() {
        const clearAllNotifications = this.notificationsService.clearAllNotification().subscribe(data => {
            this.currentUserNotifications();
        });
        this.subscriptions.push(clearAllNotifications);
    }

    clearOneNotification(id) {
        const clearNotification = this.notificationsService.clearOneNotification(id).subscribe(data => {
            this.currentUserNotifications();
        });
        this.subscriptions.push(clearNotification);
    }

    onScroll() {
        if (this.dataSize < this.maxDataSize) {
            this.dataSize += 10;
            this.currentUserNotifications();
        }
    }


    ngOnDestroy() {
        this.subscriptions.forEach(sb => sb.unsubscribe());
    }

}
